import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[40%]">
            <span className="inline-block px-3 py-1 rounded-full border border-background-300 text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              &Uuml;ber OOPBUY Spreadsheet
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Der vertrauensw&uuml;rdige
              <br />
              <span className="text-foreground-400 font-medium">Einkaufsassistent 2026</span>
            </h2>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
              Das <strong>OOPBUY Spreadsheet</strong> ist die umfassendste deutschsprachige Ressource
              f&uuml;r sicheres und effizientes Online-Shopping aus China. Speziell f&uuml;r den DACH-Raum
              entwickelt, bietet es strukturierte Kategorien, direkte Links zu vertrauensw&uuml;rdigen
              Shops auf Plattformen wie Taobao, Weidian und 1688 sowie integrierte QC-Checks und
              Versandinformationen. Unsere Mission ist es, deutschen, &ouml;sterreichischen und
              Schweizer K&auml;ufern den Zugang zu globalen M&auml;rkten so einfach und sicher wie
              m&ouml;glich zu machen.
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              Mit &uuml;ber <strong>14 sorgf&auml;ltig kuratierten Kategorien</strong> &ndash; von Schuhen
              und Hoodies bis zu Accessoires und Parfums &ndash; finden Sie genau das, was Sie suchen.
              Das OOPBUY Spreadsheet wird kontinuierlich aktualisiert, sodass Sie stets Zugriff
              auf die neuesten Produkte, Shops und Rabattaktionen haben.
            </p>

            <Link
              to="/artikel/oopbuy-spreadsheet-guide"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors group"
            >
              <span>Zum ausf&uuml;hrlichen SEO-Leitfaden</span>
              <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="lg:w-[55%]">
            <div className="flex items-end justify-end gap-4 mb-8">
              <div className="text-right">
                <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">14+</p>
                <p className="text-xs text-foreground-500 mt-1">Kategorien</p>
              </div>
              <div className="w-px h-12 bg-background-300" />
              <div className="text-right">
                <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">99+</p>
                <p className="text-xs text-foreground-500 mt-1">TrustScore</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div
                className="w-[180px] h-[180px] md:w-[200px] md:h-[200px] rounded-2xl bg-cover bg-center flex-shrink-0 mt-8"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Closeup%20macro%20detail%20of%20premium%20sneaker%20leather%20texture%20with%20fine%20stitching%20and%20lace%20eyelet%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20light%20minimal%20editorial%20photography%20European%20luxury%20aesthetic%20clean%20modern%20craftsmanship%20detail&width=400&height=400&seq=about-small-v2&orientation=squarish')`,
                }}
              />
              <div
                className="w-[220px] h-[300px] md:w-[260px] md:h-[350px] rounded-2xl bg-cover bg-center flex-shrink-0"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Designer%20tote%20bag%20in%20rich%20cognac%20brown%20leather%20with%20clean%20warm%20ivory%20studio%20backdrop%20soft%20natural%20daylight%20minimal%20composition%20editorial%20product%20photography%20European%20modern%20luxury%20aesthetic%20sophisticated%20elegant%20simplicity&width=520&height=700&seq=about-large-v2&orientation=portrait')`,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}